import React from 'react';

const AboutSection = () => {
    return (
        <section id="about" className="section about-section">
            <div className="container">
                <div className="about-grid">
                    <div className="about-content">
                        <h2 className="section-title" style={{ textAlign: 'left', marginBottom: '2rem' }}>
                            About Me
                        </h2>
                        <p className="about-text">
                            I'm a Senior E-commerce Engineer with deep expertise in ecommerce platforms,
                            specializing in <strong>BigCommerce</strong>, <strong>Magento 2</strong>, and <strong>Shopware 6</strong>.
                            I focus on building performant, accessible, and scalable administration and 
                            storefront experiences that drive conversion and delight users.
                        </p>
                        <p className="about-text">
                            My work spans performance optimization, custom checkout flows,
                            third-party integrations (ERP, PIM, payment gateways), and frontend
                            architecture design. I'm passionate about clean code, component-driven
                            development, and staying at the forefront of ecommerce technology.
                        </p>
                    </div>

                    <div className="about-specialties">
                        <h3 className="about-specialties-title">Core Specialties</h3>
                        <ul className="about-specialties-list">
                            <li>
                                <span className="specialty-icon">⚡</span>
                                <span>Performance Optimization</span>
                            </li>
                            <li>
                                <span className="specialty-icon">🛒</span>
                                <span>Checkout Flow Development</span>
                            </li>
                            <li>
                                <span className="specialty-icon">🔌</span>
                                <span>API & Third-Party Integrations</span>
                            </li>
                            <li>
                                <span className="specialty-icon">🏗️</span>
                                <span>Frontend Architecture</span>
                            </li>
                            <li>
                                <span className="specialty-icon">🎨</span>
                                <span>Component-Driven Design Systems</span>
                            </li>
                            <li>
                                <span className="specialty-icon">📱</span>
                                <span>Responsive & Mobile-First UX</span>
                            </li>
                        </ul>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default AboutSection;